import { useMutation } from "@tanstack/react-query";
import { dfetch } from "src/utils/dfetch.ts";

/**
 * DELETE `/api/envs/{env_name}`
 */
export const useDeleteEnvMutation = () => {
  return useMutation({
    mutationFn: (env_name: string) =>
      dfetch(`/api/envs/${env_name}`, {}, "DELETE").invalidate(),
  });
};
